import React from "react"
import { Link } from "@mui/material"

const HeaderLink = (props) => {
  return (
    <Link href={props.link} id={props.id} underline="hover">
      {props.linkName}
    </Link>
  )
}

export default HeaderLink
